import clsx from 'clsx';
import React from 'react';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import Button from '../Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';

interface WithdrawRequestModalProps {
  otherClasses?: string;
  handleMutation: () => void;
  handleClose: () => void;
  disbale: boolean;
  isReviewPullBack?: boolean;
}

const WithdrawRequestModal: React.FC<WithdrawRequestModalProps> = ({
  otherClasses,
  handleMutation,
  handleClose,
  disbale,
  isReviewPullBack,
}) => {
  const withdrawRequestModalClasses = clsx(otherClasses);

  const lg = useButtonSizeLarge();
  return (
    <div
      className={withdrawRequestModalClasses}
      data-testid="withdraw-request-modal"
    >
      <div className="flex flex-col items-center gap-2.5 text-center">
        <WarningIcon className="h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink">
          {isReviewPullBack
            ? `Pull Back Review?`
            : `Withdraw Extension Request?`}{' '}
        </h4>
        <p className="font-inter-variable text-brand-posh-pink text-lg leading-5 font-normal">
          {isReviewPullBack
            ? `Are you sure you want to pull back review? This action
          cannot be undone.`
            : `Are you sure you want to withdraw this extension request? This action
          cannot be undone.`}
        </p>
      </div>
      <div className="mt-6 flex flex-col-reverse gap-2.5 sm:grid sm:grid-cols-2 sm:gap-6">
        <Button
          otherClasses="bg-white !text-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink "
          size={lg}
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        <Button
          otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:bg-transparent hover:border-brand-posh-pink"
          size={lg}
          disable={disbale}
          loading={disbale}
          onClick={() => handleMutation()}
        >
          {isReviewPullBack ? `Pull Back` : `Withdraw Request`}
        </Button>
      </div>
    </div>
  );
};

export default WithdrawRequestModal;
